// extracted by mini-css-extract-plugin
export default {"txhd":"HomeTop_txhd__NgEYX","txhd1":"HomeTop_txhd1__ZPS2a","points":"HomeTop_points__Xf6Na","skycloud1":"HomeTop_skycloud1__2SAx4","skycloud2":"HomeTop_skycloud2__Ty3pz"};